@let loading = isSettingsLoading$ | async;

<button
  type="button"
  uiKitIconButton
  class="sidebar-collapse-toggle"
  color="white"
  [attr.aria-label]="isPinned() ? 'Unpin sidebar' : 'Pin sidebar'"
  [attr.aria-pressed]="isPinned()"
  (click)="onPinToggle()"
>
  <ui-kit-icon [icon]="isPinned() ? 'pushpin-fill' : 'pushpin'" color="white"/>
</button>

<div class="sidebar-menu-wrapper">
  @if (isAdminMode$ | async) {
    <button
      type="button"
      class="admin-exit-button"
      testId="admin-exit-button"
      uiKitButton
      theme="ghost"
      color="white"
      (click)="onExitAdmin()"
    >
      <ui-kit-icon icon="arrow-left" color="white"/>
      <span class="admin-exit-button__label">Exit Admin</span>
    </button>
  }

  <app-side-bar-navigation
    class="side-bar-navigation"
    [class.side-bar-navigation--loading]="loading"
    [isCollapsed]="isAutoCollapsed()"
    [menuItemGroups]="menuItemGroups$ | async"
  />

  @if (loading) {
    <div class="sidebar-loading">
      <ui-kit-icon icon="loading" size="large" color="white"/>
    </div>
  }
</div>

<div class="sidebar-font-controls">
  <app-font-size-controls-container [isCollapsible]="isAutoCollapsed()"/>
</div>

@if (isResizable()) {
  <div
    class="sidebar-resize-handle"
    tabindex="0"
    aria-label="Resize sidebar"
    aria-orientation="vertical"
    role="separator"
    [attr.aria-valuemin]="minSidebarWidth"
    [attr.aria-valuemax]="maxSidebarWidth"
    [attr.aria-valuenow]="sidebarWidth()"
    (mousedown)="onResizeStart($event)"
    (keydown)="onResizeHandleKeydown($event)"
  ></div>
}

